module.exports = __webpack_public_path__ + "static/corinthian-doors-logo-65e18da165dd77b78488d8a6edbd0872.png";